import { render } from "./TabsMain.vue?vue&type=template&id=5f93f04f"
import script from "./TabsMain.vue?vue&type=script&lang=js"
export * from "./TabsMain.vue?vue&type=script&lang=js"

import "./TabsMain.vue?vue&type=style&index=0&id=5f93f04f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__